import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const maxList = 3;

export default function ExpandableList({ collection, renderItem }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const isBeyondShowableLimit = collection.length > maxList;

  return (
    <>
      <ul className='tw-m-0 tw-pl-4'>
        {collection.slice(0, maxList).map(renderItem)}
        {isBeyondShowableLimit &&
          isExpanded &&
          collection.slice(maxList).map(renderItem)}
      </ul>
      {isBeyondShowableLimit && !isExpanded && (
        <a
          className='app-link tw-text-s tw-tracking-wide tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
          href='#0'
          onClick={() => setIsExpanded(true)}
        >
          {i18nTShared('other', { count: collection.length - maxList })}
        </a>
      )}
    </>
  );
}

ExpandableList.propTypes = {
  collection: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
};
